module.exports = __webpack_public_path__ + "static/media/signature-hand.484798c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/signature-hand.svg
// module id = 586
// module chunks = 9